import { Config } from "../../services/Config";
import { ContextItem } from "../Context";

class FormConstructorData {
  public ClientWebsiteId: string = Config.Website.Id;
  public Items: ContextItem[];

  constructor(items?: ContextItem[]) {
    this.Items = items || [];
  }
}

export { FormConstructorData }
